import React from "react";
import { I18nextProvider } from "react-i18next";
import i18n from "./logic";

export function AppTranslateProvider({ children }: React.PropsWithChildren) {
  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}
